import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './TerceirizacaoPage.css';

const TerceirizacaoPage = () => {
  return (
    <>
      <Header />
      
      <div className="terceirizacao-container">
        <div className="terceirizacao-content">
          <div className="terceirizacao-left">
            <div className="terceirizacao-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">TERCEIRIZAÇÃO DE PROCESSOS</h1>
            </div>
          </div>
          
          <div className="terceirizacao-right">
            <div className="terceirizacao-description">
              <p>
                Otimize rotinas jurídicas e administrativas com apoio especializado e tecnologia 
                dedicada.
              </p>
              
              <ul className="terceirizacao-services">
                <li>
                  <strong>Tributário:</strong> organização de documentos fiscais e acompanhamento de prazos
                </li>
                <li>
                  <strong>Cível:</strong> gestão de fluxos processuais e suporte em demandas administrativas
                </li>
                <li>
                  <strong>Societário:</strong> estruturação e controle de registros societários e corporativos
                </li>
              </ul>
              
              <p>
                A Veridicus transforma a terceirização de processos em um modelo seguro e eficiente. Nossa tecnologia centraliza 
                informações, automatiza tarefas repetitivas e gera relatórios que facilitam o acompanhamento de cada etapa.
              </p>
              
              <p>
                Escritórios e departamentos jurídicos ganham mais capacidade de resposta, reduzem a sobrecarga operacional e 
                mantêm foco nas decisões estratégicas, enquanto nós cuidamos da execução estruturada e precisa das rotinas de 
                suporte.
              </p>
            </div>
            
            <div className="terceirizacao-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="terceirizacao-navigation">
          <Link to="/servicos/backoffice" className="nav-prev">
            ← BACKOFFICE
          </Link>
          <Link to="/servicos/apoio-juridico" className="nav-next">
            APOIO A ESCRITÓRIOS E DEPARTAMENTOS JURÍDICOS →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default TerceirizacaoPage;